import { render, staticRenderFns } from "./WithholdingCard.vue?vue&type=template&id=27bd50d3&"
import script from "./WithholdingCard.vue?vue&type=script&lang=js&"
export * from "./WithholdingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports